import * as React from "react"
import { Box, Link, Typography, Badge } from "@mui/material";
import { TooltipSeeker } from "@ui-seeker/core";
import { formatPercentage, formatPriceSymbol } from "@ui-seeker/utils";

import { useBuildExternalURL } from "@hooks"


export default function PricingPriceBlock({ price, currency, diff, retailer, reverse=false, propsTypography, siteID, productID, propsContainer, date, stock, userUseRRSP, priceTooltip='', stockTooltip=[] }) {
	const validDiff = diff !== null && diff !== undefined
	const diffComparator = reverse ? diff * -1 : diff
	const { productURL } = useBuildExternalURL({ siteData: { siteID, productID } })

	return <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', ...propsContainer?.sx }}>
		<Typography {...propsTypography}>
			<Box sx={{ display: 'flex', alignItems: 'center' }}>
				<TooltipSeeker title={priceTooltip}>
					<Box>{formatPriceSymbol(price, currency)}</Box>
				</TooltipSeeker>

				{ validDiff && !!userUseRRSP && <Typography variant="caption" sx={{ color: diffComparator <= 0 ? 'success.dark' : 'error.main', ml: .5}}>
					{formatPercentage(diff)}
				</Typography> }

				{(!!stock || stock === 0) && <TooltipSeeker
					title={
						stock
							? (stockTooltip?.length > 0 ? stockTooltip[0] : 'In Stock')
							: (stockTooltip?.length > 0 ? stockTooltip[1] : 'Out of Stock')
					}
					sx={{mt: 2}} >
					<Badge
						color={stock ? 'success' : 'error'}
						badgeContent=""
						sx={{ ml: 2 }}
					/>
				</TooltipSeeker>}
			</Box>
		</Typography>
		{ retailer && <Typography variant="caption" sx={{ fontStyle: 'italic', pr: 1, fontSize: 11 }}>
			{ productURL ? <Link href={productURL} target="_blank">
				{retailer}
			</Link> : retailer }
		</Typography> }
	</Box>
}